// src/pages/AdminLogin.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { signInWithEmailAndPassword, sendPasswordResetEmail } from "firebase/auth";
import { auth } from "../firebase";
import toast from "react-hot-toast";

// ── Logo corazón SVG ──────────────────────────────────
const HEART_PATHS = [
  { fill:"#FD9391", transform:"translate(89,24)",  d:"M0 0 C3.52 1.97 5.70 4.10 7 8 C7.09 9.55 7.12 11.10 7.11 12.65 C7.11 13.61 7.11 14.56 7.11 15.55 C7.11 16.59 7.10 17.64 7.10 18.72 C7.10 19.82 7.09 20.93 7.09 22.07 C7.09 24.47 7.08 26.88 7.08 29.28 C7.06 33.10 7.06 36.92 7.05 40.74 C7.04 49.55 7.02 58.37 6.99 67.18 C6.97 75.87 6.96 84.56 6.94 93.25 C6.94 96.99 6.93 100.73 6.91 104.46 C6.89 116.68 7.05 128.82 8 141 C3.08 140.25 1.39 138.67 -2 135 C-4.87 132.38 -7.77 129.79 -10.67 127.21 C-13.93 124.12 -13.93 124.12 -14.13 120.96 C-14.13 120.11 -14.14 119.26 -14.14 118.39 C-14.15 117.42 -14.15 116.45 -14.16 115.45 C-14.16 114.38 -14.16 113.31 -14.16 112.20 C-14.17 111.08 -14.17 109.96 -14.18 108.80 C-14.19 105.07 -14.20 101.34 -14.20 97.61 C-14.21 95.02 -14.21 92.43 -14.22 89.85 C-14.23 85.11 -14.24 80.38 -14.24 75.65 C-14.24 68.68 -14.26 61.72 -14.29 54.75 C-14.31 48.72 -14.32 42.68 -14.32 36.65 C-14.33 34.08 -14.33 31.52 -14.35 28.95 C-14.36 25.36 -14.36 21.77 -14.36 18.18 C-14.37 17.12 -14.37 16.06 -14.38 14.96 C-14.33 5.85 -14.33 5.85 -11 2 C-7.31 -0.46 -4.28 -0.81 0 0 Z" },
  { fill:"#F9A723", transform:"translate(61,5)",   d:"M0 0 C2.97 1.78 5.43 3.85 7 7 C7.10 8.42 7.14 9.84 7.15 11.26 C7.16 12.16 7.17 13.05 7.18 13.97 C7.18 14.96 7.19 15.94 7.19 16.95 C7.20 17.99 7.21 19.02 7.22 20.09 C7.24 23.52 7.26 26.96 7.27 30.39 C7.28 31.56 7.28 32.73 7.29 33.94 C7.32 40.14 7.34 46.34 7.35 52.54 C7.37 58.94 7.41 65.35 7.46 71.76 C7.50 76.68 7.51 81.60 7.51 86.53 C7.52 88.89 7.54 91.25 7.56 93.61 C7.59 96.92 7.59 100.22 7.58 103.53 C7.60 104.50 7.62 105.48 7.63 106.49 C7.59 110.95 7.46 114.03 4.59 117.60 C1.50 120.47 0.06 121.02 -4.00 121.23 C-7.49 120.83 -9.45 119.31 -12 117 C-14.68 112.27 -14.30 107.26 -14.29 101.98 C-14.30 100.98 -14.30 99.97 -14.31 98.93 C-14.33 95.61 -14.33 92.29 -14.34 88.97 C-14.34 86.66 -14.35 84.35 -14.36 82.04 C-14.37 77.20 -14.37 72.36 -14.37 67.52 C-14.37 61.32 -14.40 55.12 -14.43 48.91 C-14.45 44.14 -14.46 39.37 -14.46 34.60 C-14.46 32.31 -14.47 30.03 -14.48 27.74 C-14.50 24.54 -14.50 21.35 -14.49 18.15 C-14.50 17.21 -14.51 16.26 -14.52 15.29 C-14.47 9.70 -13.80 6.39 -10 2 C-6.23 -0.51 -4.47 -0.53 0 0 Z" },
  { fill:"#61CACD", transform:"translate(143,19)", d:"M0 0 C3.80 1.73 5.43 3.17 7 7 C7.26 8.95 7.26 8.95 7.27 11.02 C7.28 11.81 7.28 12.59 7.29 13.41 C7.29 14.26 7.29 15.12 7.29 16.00 C7.30 17.37 7.30 17.37 7.31 18.76 C7.33 21.77 7.33 24.77 7.34 27.78 C7.34 29.87 7.35 31.96 7.36 34.05 C7.37 38.43 7.37 42.81 7.37 47.19 C7.37 52.80 7.40 58.41 7.43 64.03 C7.45 68.34 7.46 72.66 7.46 76.98 C7.46 79.05 7.47 81.12 7.48 83.19 C7.50 86.08 7.50 88.97 7.49 91.87 C7.50 92.72 7.51 93.58 7.52 94.46 C7.48 98.46 7.29 100.52 5.16 104.01 C2.36 106.59 0.44 106.95 -3.31 107.38 C-8.25 106.87 -9.61 105.56 -13 102 C-14.38 97.92 -14.16 93.73 -14.16 89.47 C-14.17 88.61 -14.17 87.75 -14.18 86.87 C-14.19 84.03 -14.20 81.19 -14.20 78.35 C-14.21 76.38 -14.21 74.40 -14.22 72.43 C-14.23 68.28 -14.24 64.14 -14.24 60.00 C-14.25 54.70 -14.27 49.40 -14.30 44.10 C-14.32 40.02 -14.32 35.94 -14.32 31.86 C-14.33 29.90 -14.33 27.95 -14.35 25.99 C-14.36 23.26 -14.36 20.52 -14.36 17.79 C-14.37 16.98 -14.37 16.18 -14.38 15.35 C-14.35 10.50 -13.66 7.21 -11 3 C-7.37 0.06 -4.62 -0.58 0 0 Z" },
  { fill:"#FDA8AB", transform:"translate(116,37)", d:"M0 0 C5.56 3.34 5.56 3.34 6.55 7.09 C6.78 9.73 6.80 12.30 6.76 14.94 C6.77 15.94 6.78 16.94 6.79 17.97 C6.81 21.26 6.79 24.55 6.76 27.84 C6.76 30.13 6.77 32.42 6.77 34.71 C6.78 39.51 6.76 44.31 6.73 49.11 C6.69 55.26 6.70 61.41 6.72 67.56 C6.74 72.29 6.73 77.02 6.71 81.75 C6.70 84.01 6.70 86.28 6.71 88.55 C6.72 91.72 6.70 94.89 6.66 98.06 C6.67 99.00 6.68 99.93 6.69 100.90 C6.61 105.39 6.47 107.38 3.67 111.05 C0.25 113.55 -1.76 114.15 -6 114 C-9.03 112.27 -11.42 110.16 -13 107 C-13.12 104.75 -13.18 102.49 -13.21 100.24 C-13.22 99.54 -13.23 98.84 -13.24 98.13 C-13.27 95.81 -13.29 93.49 -13.32 91.17 C-13.34 89.55 -13.36 87.92 -13.38 86.29 C-13.42 82.87 -13.46 79.44 -13.50 76.01 C-13.56 70.84 -13.63 65.67 -13.69 60.50 C-13.79 53.16 -13.86 45.82 -13.93 38.47 C-13.97 33.95 -14.04 29.44 -14.13 24.92 C-14.16 22.95 -14.19 20.98 -14.21 19.02 C-14.24 18.17 -14.26 17.33 -14.29 16.46 C-14.34 10.52 -13.38 5.63 -9.25 1.06 C-5.90 -0.52 -3.66 -0.50 0 0 Z" },
  { fill:"#FA665E", transform:"translate(35,27)",  d:"M0 0 C3.23 2.75 4.73 4.46 5.46 8.66 C5.65 11.99 5.67 15.29 5.63 18.63 C5.63 19.85 5.63 21.07 5.64 22.32 C5.64 24.90 5.62 27.47 5.60 30.05 C5.56 33.99 5.58 37.92 5.60 41.86 C5.59 44.36 5.58 46.87 5.57 49.38 C5.57 50.55 5.58 51.73 5.58 52.94 C5.49 59.23 5.29 63.24 1 68 C-1.70 70.14 -2.99 70.00 -6.50 69.88 C-10.31 68.92 -11.65 68.08 -14 65 C-15.01 61.96 -15.14 59.87 -15.16 56.69 C-15.17 55.61 -15.18 54.52 -15.19 53.40 C-15.19 52.23 -15.20 51.06 -15.20 49.85 C-15.21 48.65 -15.21 47.44 -15.22 46.20 C-15.23 43.65 -15.24 41.10 -15.24 38.55 C-15.25 34.65 -15.28 30.75 -15.31 26.84 C-15.32 24.37 -15.32 21.89 -15.33 19.41 C-15.34 18.25 -15.35 17.08 -15.37 15.88 C-15.36 14.78 -15.36 13.69 -15.36 12.57 C-15.36 11.61 -15.36 10.66 -15.37 9.67 C-14.79 5.44 -12.99 2.82 -9.75 0.13 C-5.96 -1.42 -3.90 -1.19 0 0 Z" },
  { fill:"#F0E0D2", transform:"translate(168,39)", d:"M0 0 C2.70 1.80 4.54 3.08 6 6 C6.12 7.64 6.17 9.28 6.19 10.92 C6.22 12.46 6.22 12.46 6.24 14.03 C6.29 18.72 6.33 23.40 6.35 28.09 C6.37 30.57 6.39 33.04 6.43 35.52 C6.49 39.08 6.51 42.64 6.52 46.21 C6.55 47.31 6.57 48.42 6.59 49.56 C6.57 57.21 6.57 57.21 3.69 61.20 C0.16 63.56 -1.83 63.68 -6 63 C-8.36 61.13 -9.66 59.68 -11 57 C-11.10 55.39 -11.14 53.77 -11.15 52.15 C-11.15 51.15 -11.16 50.14 -11.16 49.10 C-11.17 48.01 -11.17 46.91 -11.17 45.79 C-11.17 44.67 -11.17 43.55 -11.18 42.40 C-11.18 40.02 -11.19 37.65 -11.19 35.28 C-11.19 31.65 -11.21 28.02 -11.22 24.38 C-11.23 22.08 -11.23 19.78 -11.23 17.48 C-11.24 16.39 -11.24 15.30 -11.25 14.18 C-11.25 13.16 -11.25 12.15 -11.24 11.10 C-11.24 10.21 -11.25 9.32 -11.25 8.40 C-10.98 5.77 -10.44 4.21 -9 2 C-5.49 -0.34 -4.14 -0.50 0 0 Z" },
];

function HeartLogo({ size = 52 }) {
  const scale = size / 174;
  return (
    <svg width={198*scale} height={size} viewBox="0 0 198 174"
      xmlns="http://www.w3.org/2000/svg" style={{ flexShrink:0 }} aria-hidden="true">
      <style>{`
        @keyframes hpulse {
          0%,65%{opacity:1;transform:scale(1);}
          71%{opacity:0.5;transform:scale(0.86);}
          77%{opacity:1;transform:scale(1);}
          83%{opacity:0.72;transform:scale(0.93);}
          89%{opacity:1;transform:scale(1);}
          100%{opacity:1;transform:scale(1);}
        }
        .lhg{transform-origin:99px 87px;animation:hpulse 2.8s ease-in-out infinite;}
      `}</style>
      <g className="lhg">
        {HEART_PATHS.map((b,i) => <path key={i} d={b.d} fill={b.fill} transform={b.transform}/>)}
      </g>
    </svg>
  );
}

export default function AdminLogin() {
  const [email,    setEmail]    = useState("");
  const [password, setPassword] = useState("");
  const [loading,  setLoading]  = useState(false);
  const [mode,     setMode]     = useState("login"); // "login" | "reset"
  const [showPass, setShowPass] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!email || !password) { toast.error("Completa email y contraseña"); return; }
    setLoading(true);
    try {
      await signInWithEmailAndPassword(auth, email, password);
      toast.success("¡Bienvenido!");
      navigate("/admin");
    } catch (err) {
      const msgs = {
        "auth/user-not-found":  "No existe una cuenta con ese email",
        "auth/wrong-password":  "Contraseña incorrecta",
        "auth/invalid-email":   "Email no válido",
        "auth/too-many-requests":"Demasiados intentos. Intenta más tarde",
        "auth/invalid-credential":"Email o contraseña incorrectos",
      };
      toast.error(msgs[err.code] || "Error al iniciar sesión");
    } finally { setLoading(false); }
  };

  const handleReset = async (e) => {
    e.preventDefault();
    if (!email) { toast.error("Ingresa tu email primero"); return; }
    setLoading(true);
    try {
      await sendPasswordResetEmail(auth, email);
      toast.success("✉️ Revisa tu correo — te enviamos el enlace para restablecer tu contraseña");
      setMode("login");
    } catch (err) {
      const msgs = {
        "auth/user-not-found": "No existe cuenta con ese email",
        "auth/invalid-email":  "Email no válido",
      };
      toast.error(msgs[err.code] || "No se pudo enviar el correo");
    } finally { setLoading(false); }
  };

  return (
    <div className="login-page">
      <div className="login-card">

        {/* ENCABEZADO CON LOGO */}
        <div style={{ display:"flex", flexDirection:"column", alignItems:"center", marginBottom:28 }}>
          <HeartLogo size={52} />
          <div style={{ marginTop:12, textAlign:"center" }}>
            <div style={{
              fontFamily:"var(--font-display)", fontSize:22, fontWeight:800,
              color:"var(--ink)", letterSpacing:"-0.02em", lineHeight:1
            }}>
              <span style={{ color:"#FA665E" }}>con</span>el
              <span style={{ color:"#FA665E" }}>corazon</span>
              <span style={{ fontSize:13, color:"var(--text-muted)", fontWeight:700 }}>.co</span>
            </div>
            <p style={{ fontSize:11, fontWeight:700, letterSpacing:"0.12em",
              textTransform:"uppercase", color:"var(--text-muted)", marginTop:4 }}>
              Panel de administración
            </p>
          </div>
        </div>

        {/* TÍTULO */}
        <h1 style={{ fontFamily:"var(--font-display)", fontSize:22, fontWeight:700,
          color:"var(--ink)", marginBottom:24, textAlign:"center" }}>
          {mode === "login" ? "Iniciar sesión" : "Recuperar contraseña"}
        </h1>

        {/* FORMULARIO LOGIN */}
        {mode === "login" && (
          <form onSubmit={handleLogin}>
            <div className="form-field">
              <label>Email</label>
              <input
                type="email"
                placeholder="admin@conelcorazon.co"
                value={email}
                onChange={e => setEmail(e.target.value)}
                autoComplete="email"
                required
              />
            </div>
            <div className="form-field" style={{ position:"relative" }}>
              <label>Contraseña</label>
              <input
                type={showPass ? "text" : "password"}
                placeholder="••••••••"
                value={password}
                onChange={e => setPassword(e.target.value)}
                autoComplete="current-password"
                required
                style={{ paddingRight:48 }}
              />
              <button
                type="button"
                onClick={() => setShowPass(!showPass)}
                style={{
                  position:"absolute", right:12, top:36,
                  background:"none", border:"none", cursor:"pointer",
                  color:"var(--text-muted)", fontSize:18, padding:4,
                }}
                aria-label={showPass ? "Ocultar contraseña" : "Mostrar contraseña"}
              >
                {showPass ? "🙈" : "👁️"}
              </button>
            </div>

            {/* Olvidé mi contraseña */}
            <div style={{ textAlign:"right", marginTop:-8, marginBottom:20 }}>
              <button
                type="button"
                onClick={() => setMode("reset")}
                style={{ color:"var(--coral)", fontSize:13, fontWeight:600,
                  background:"none", border:"none", cursor:"pointer",
                  fontFamily:"var(--font-body)", textDecoration:"underline" }}
              >
                ¿Olvidaste tu contraseña?
              </button>
            </div>

            <button
              type="submit"
              className="btn-primary btn-full btn-big"
              disabled={loading}
            >
              {loading ? "Entrando..." : "Ingresar al panel"}
            </button>
          </form>
        )}

        {/* FORMULARIO RECUPERAR */}
        {mode === "reset" && (
          <form onSubmit={handleReset}>
            <p style={{ fontSize:14, color:"var(--text-muted)", marginBottom:20, lineHeight:1.6 }}>
              Ingresa tu email de administrador y te enviaremos un enlace para restablecer tu contraseña.
            </p>
            <div className="form-field">
              <label>Email de administrador</label>
              <input
                type="email"
                placeholder="admin@conelcorazon.co"
                value={email}
                onChange={e => setEmail(e.target.value)}
                autoComplete="email"
                required
              />
            </div>

            <button
              type="submit"
              className="btn-primary btn-full btn-big"
              disabled={loading}
              style={{ marginBottom:12 }}
            >
              {loading ? "Enviando..." : "Enviar enlace de recuperación"}
            </button>

            <button
              type="button"
              className="btn-ghost btn-full"
              onClick={() => setMode("login")}
            >
              ← Volver al login
            </button>
          </form>
        )}

      </div>
    </div>
  );
}
